import {useParams} from "react-router-dom"

export function usePaymentArrangementId() {
	const {id} = useParams()
	if (!id) {
		console.error("Payment arrangement ID is required", window.location.href)
		throw new Error("Payment arrangement ID is required")
	}
	return id
}
